import { Checkbox as TPACheckbox, CheckboxTheme } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useMemo, useRef } from 'react';
import { useFocusFieldEvent } from '../../contexts/events-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import styles from '../../ui/checkbox-group-field/checkbox-group-field-wut.module.scss';
import { classes } from '../../ui/checkbox-group-field/checkbox-group-field-wut.st.css';
import Fieldset from '../../ui/fieldset';
import { OptionsLayout } from '../../ui/options-layout';
import { NUMBER_OF_COLUMNS } from '../../ui/options-layout/options-layout-constants';
import { OtherOptionWUT } from './other-option-wut';
export const CheckboxGroupInputWUT = ({ label, options, addOther, addOtherLabel, addOtherPlaceholder, required = false, value = null, onFocus, onBlur, disabled = false, otherInputCharacterLimit, numberOfColumns = NUMBER_OF_COLUMNS.ONE, hideBox = false, onChange, hasError, inputId, labelId, ariaDescribedBy, fieldId })=>{
    const _value = useMemo(()=>value || [], [
        value
    ]);
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    const firstCheckboxRef = useRef(null);
    const _onChange = useCallback((newValue)=>{
        onChange?.(newValue);
    }, [
        onChange
    ]);
    const handleChange = useCallback((optionName, isChecked)=>{
        const newValue = isChecked ? [
            ..._value,
            optionName
        ] : _value.filter((val)=>val !== optionName);
        _onChange(newValue);
    }, [
        _value,
        _onChange
    ]);
    useFocusFieldEvent(()=>{
        firstCheckboxRef.current?.focus({
            preventScroll: true
        });
    }, fieldId);
    return /*#__PURE__*/ React.createElement(Fieldset, {
        id: inputId,
        ariaLabelledBy: labelId,
        className: classNames(classes.checkboxGroup, {
            [classes.error]: hasError
        }),
        ariaDescribedBy: ariaDescribedBy,
        onFocus: onFocus,
        onBlur: onBlur,
        required: required
    }, /*#__PURE__*/ React.createElement(OptionsLayout, {
        numberOfColumns: numberOfColumns
    }, options?.map(({ label: optionLabel, value: optionValue, id: optionId }, index)=>{
        const checkboxValue = optionValue ?? optionLabel;
        const isChecked = _value.includes(checkboxValue);
        return /*#__PURE__*/ React.createElement(TPACheckbox, {
            error: hasError,
            disabled: disabled,
            key: `checkbox-${optionId || optionLabel}`,
            "data-hook": `checkbox-${optionLabel}`,
            checked: isChecked,
            onChange: (event)=>{
                handleChange(checkboxValue, event.checked);
            },
            name: label,
            label: optionLabel,
            className: classNames(classes.checkbox, styles.checkbox, {
                [styles.checkboxError]: hasError,
                [classes.hover]: forcedHover,
                [classes.hideBox]: hideBox
            }),
            theme: hideBox ? CheckboxTheme.Box : CheckboxTheme.Default,
            ref: index === 0 ? firstCheckboxRef : undefined
        });
    })), /*#__PURE__*/ React.createElement(OtherOptionWUT, {
        label: label,
        options: options,
        addOther: addOther,
        addOtherLabel: addOtherLabel,
        addOtherPlaceholder: addOtherPlaceholder,
        value: value,
        onChange: _onChange,
        disabled: disabled,
        hasError: hasError,
        maxLength: otherInputCharacterLimit
    }));
};

//# sourceMappingURL=checkbox-group-input-wut.js.map